import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {BsModalRef} from 'ngx-bootstrap';
import {HcaMemberService} from '../../../shared/_services/hca-member.service';

@Component({
  selector: 'app-hard-delete-member',
  templateUrl: './hard-delete-member.component.html',
  styleUrls: ['./hard-delete-member.component.scss']
})
export class HardDeleteMemberComponent implements OnInit {
  step = 1;
  memberId: number | string;
  memberEmail = '';
  cardCode = '';
  srcObject: any = {action: ''};
  form: FormGroup;
  loading = false;
  errorMsg = '';
  successMsg = '';

  constructor(
    private fb: FormBuilder,
    public bsModalRef: BsModalRef,
    private hcaMemberService: HcaMemberService
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      confirmEmail: ['', Validators.required],
      reason: ['', Validators.maxLength(500)],
      acknowledged: [false]
    });
  }

  get canConfirm(): boolean {
    if (!this.form) {
      return false;
    }
    const typed = (this.form.get('confirmEmail').value || '').trim().toLowerCase();
    const expected = (this.memberEmail || '').trim().toLowerCase();
    return !!typed && typed === expected && !!this.form.get('acknowledged').value && !this.loading;
  }

  continueToConfirm() {
    this.errorMsg = '';
    this.step = 2;
  }

  backToWarning() {
    this.errorMsg = '';
    this.step = 1;
  }

  confirmDelete() {
    if (!this.canConfirm) {
      return;
    }
    this.loading = true;
    this.errorMsg = '';
    const body: any = {
      confirmEmail: (this.form.get('confirmEmail').value || '').trim()
    };
    const reason = (this.form.get('reason').value || '').trim();
    if (reason) {
      body.reason = reason;
    }
    this.hcaMemberService.hardDeleteMember(this.memberId, body).subscribe(res => {
      this.loading = false;
      if (res && res.error === 0) {
        const result = res.responseObj || {};
        const deletedEmail = result.email ? result.email : this.memberEmail;
        let msg = 'Member ' + deletedEmail + ' was permanently deleted.';
        if (result.auditId != null) {
          msg += ' Audit ID: ' + result.auditId + '.';
        }
        if (result.coinsBalance != null) {
          msg += ' Coins balance: ' + result.coinsBalance + '.';
        }
        this.successMsg = msg;
        this.srcObject.action = 'action1';
        this.srcObject.type = 'hard-delete';
        this.srcObject.auditId = result.auditId;
        setTimeout(() => {
          this.bsModalRef.hide();
        }, 1800);
      } else {
        this.errorMsg = res && res.message ? res.message : 'Unable to delete member.';
      }
    }, err => {
      this.loading = false;
      if (err && err.status === 403) {
        this.errorMsg = 'Not authorized to permanently delete members.';
      } else {
        this.errorMsg = err && err.message ? err.message : 'Unable to delete member.';
      }
    });
  }

  closeModal() {
    if (this.loading) {
      return;
    }
    this.srcObject.action = 'action2';
    this.bsModalRef.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/hard-delete-member/hard-delete-member.component.ts